import React, { useState, useEffect } from 'react'
import { Table, TableBody, TableCell, TableContainer, Pagination, TableHead, TableRow, Dialog } from '@mui/material'
import { useSelector } from 'react-redux';
import ConfigurationsHook from '../hooks/ConfigurationsHook';
import { useAuthContext } from '../hooks/adminAuthHook'
import toast from 'react-hot-toast'
import { useParams } from "react-router-dom";
// import Chip from '@mui/material/Chip';
// import AddIcon from '@mui/icons-material/Add';
export default function Configurations() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const configurations = useSelector((state) => state.configurations.configurations);

  const { getConfigurations } = ConfigurationsHook();
  useEffect(() => {
    getConfigurations()
    document.title = "Configurations"
  }, [])


  let { type } = useParams()
  const { admin } = useAuthContext()
  // Airports
  const [airport_name, setairport_name] = useState("");
  const [country, setcountry] = useState("");
  const [iata_code, setiata_code] = useState("");
  const [icao_code, seticao_code] = useState();
  const [airline_logo, setairline_logo] = useState("");

  // Airlines
  const [name, setname] = useState("");
  const [callsign, setcallsign] = useState("");
  // Flight Class
  const [flight_class, setflight_class] = useState("");

  const [isActive, setActive] = useState(true);

  const handleToggle = () => {
    setActive(!isActive);
  };


  // Handle image selection
  const handleImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        alert('File size exceeds the 5MB limit. Please select a smaller file.');
      } else {
        TransformFile(file);
      }
    }
  };
  // Transform file to base64
  const TransformFile = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setairline_logo(reader.result,
      );
    };
  }

  // Config Edition
  const [editedConfig, setEditedConfig] = useState(null)

  const [openNew, setOpenNew] = React.useState(false);
  const handleClickOpenNew = () => {
    setOpenNew(true);
  };

  const handleCloseNew = () => {
    setEditedConfig('');
    setOpenNew(false);
    setairport_name('')
    setcountry('')
    setiata_code('')
    seticao_code('')
    setairline_logo('')
    setname('')
    setcallsign('')
    setflight_class('')
    setActive(false)
  }

  const handleEditView = (data) => {
    setEditedConfig(data);
    setOpenNew(true);
    setairport_name(data.airport_name)
    setcountry(data.country)
    setiata_code(data.iata_code)
    seticao_code(data.icao_code)
    setairline_logo(data.airline_logo)
    setname(data.name)
    setcallsign(data.callsign)
    setflight_class(data.flight_class)
    setActive(data.isActive || false)

  }

  // API Call to add a new Configu
  const [loading1, setLoading1] = useState(false)
  const addNewConfigu = async (e) => {
    e.preventDefault()
    setLoading1(true)
    try {
      const response = await fetch(`${apiUrl}/api/admin/configurations/add`, {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${admin.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { type,airport_name,country,iata_code,icao_code,airline_logo,name,callsign,flight_class } })
      })
      const json = await response.json()
      if (response.ok) {
        toast.success(json.message)
        getConfigurations()

        setLoading1(null)
        handleCloseNew()
      }
      if (!response.ok) {
        toast.error(json.message)
        setLoading1(null)
      }
    } catch (error) {
      setLoading1(null)
    }
  }

  const updateConfigu = async (e) => {
    e.preventDefault()
    setLoading1(true)
    try {
      const response = await fetch(`${apiUrl}/api/admin/configurations/update`, {
        method: "PUT",
        headers: {
          'Authorization': `Bearer ${admin.token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { _id: editedConfig._id, type,airport_name,country,iata_code,icao_code,airline_logo,name,callsign,flight_class, isActive } })
      })

      const json = await response.json()
      if (response.ok) {
        toast.success(json.message)
        getConfigurations()
        setLoading1(null)
        handleCloseNew()
      }
      if (!response.ok) {
        toast.error(json.message)
        setLoading1(null)
      }
    } catch (error) {
      setLoading1(null)
    }
  }

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 10;


  // Handle search input change
  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setPage(value);
  };
  const filteredConfigurations = configurations && configurations
    .filter(configu => {
      const matchesSearch = (
        configu?.type?.trim().toLowerCase() === type.trim().toLowerCase()
      );

      return matchesSearch
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));


  // Paginate the filtered categories
  const paginatedConfigurations = filteredConfigurations.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );


  //deleting the configuration

  const [delLoading, setDelLoading] = useState(false)
  const deleteConfigu = async (configId) => {
    if (window.confirm('Are you sure you want to delete?')) {
      setDelLoading(true)
      try {
        const response = await fetch(`${apiUrl}/api/admin/configurations/delete`, {
          method: "DELETE",
          headers: {
            'Authorization': `Bearer ${admin.token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ configId })
        })

        const json = await response.json()
        if (response.ok) {
          toast.success(json.message)
          getConfigurations()
          setDelLoading(null)
        }
        if (!response.ok) {
          toast.error(json.message)
          setDelLoading(null)
        }
      } catch (error) {
        setDelLoading(null)
      }
    }
  }



  const collapsed = useSelector((state) => state.collapsed.collapsed);
  return (
    <div className={`${collapsed ? "collapsed mt-5 " : "main mt-5"}`}>
      <div className="container-fluid bg-none my-0 mt-4">
        <div className="row px-2 mt-5 pt-4">
          <div className="col-md-12 data_table p-2 pb-3">
            <div className="d-flex justify-content-between searchbar pb-2 pt-2 px-md-3 my-auto">
              <div className="d-flex left my-auto mb-2 mb-md-0 ps-3 ps-md-0">
                <h6>{type}</h6>
              </div>
              <div className="d-flex right my-auto">
                {/* <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6 search_icon_svg">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>
                <input type="text"  value={search} onChange={handleSearchChange} placeholder='Seacrh..' /> */}
                <button className='add_btn btn ms-1' onClick={() => handleClickOpenNew()}>Add {type.endsWith('ss') ? type : type.endsWith('ies') ? type.slice(0, -3) + 'y' : type.endsWith('s') ? type.slice(0, -1) : type}</button>
              </div>
            </div>
            <TableContainer>
              <Table sx={{ minWidth: 650 }} stickyHeader aria-label="simple table" className='text-center'>
                <TableHead >
                  <TableRow >
                    <TableCell className='th text-center' >SN</TableCell>
                   
                      <TableCell className='th text-center'>Name</TableCell>
                    {(type === 'airports' || type === 'airlines') &&
                      <>
                        <TableCell className='th text-center'>Country</TableCell>
                        <TableCell className='th text-center'>IATA Code</TableCell>
                        <TableCell className='th text-center'>ICAO Code</TableCell>

                      </>
                    }
                    {(type === 'airlines') &&
                      <TableCell className='th text-center'>Call Sign</TableCell>
                    }

                    <TableCell className='th text-center'>Status</TableCell>
                    <TableCell className='th text-center'>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {paginatedConfigurations && paginatedConfigurations.length > 0 ? paginatedConfigurations
                    .map((data, index) => (
                      <>
                        <TableRow className='table_row'>
                          <TableCell className='text-center td'>{index + 1}</TableCell>

                          {/* Flight Class */}
                          {type === 'flight class' &&
                            <TableCell className='td text-center'>{data.flight_class}</TableCell>
                          }
                          {/* Airports */}
                          {type === 'airports' &&
                            <TableCell className='td text-center'>{data.airport_name}</TableCell>
                          }
                          {/* Airlines */}
                          {(type === 'airlines'||type === 'hotels') &&
                            <TableCell className='td text-center'>{data.name}</TableCell>
                          }

                          {(type === 'airports' || type === 'airlines') &&
                            <>
                              <TableCell className='td text-center'>{data.country}</TableCell>
                              <TableCell className='td text-center'>{data.iata_code}</TableCell>
                              <TableCell className='td text-center'>{data.icao_code}</TableCell>
                            </>
                          }

                          {(type === 'airlines') &&
                            <TableCell className='td text-center'>{data.callsign}</TableCell>
                          }

                          <TableCell className='text-center td'>{data.isActive ? <span className='active_status'><i className="fa-solid fa-circle-notch"></i> Active</span> : <span className='inactive_status'><i className="fa-solid fa-circle-notch"></i> Inactive</span>}</TableCell>
                          <TableCell className='td text-center'>
                            <div className="btn-group" role="group" aria-label="Basic example">
                              <button onClick={() => handleEditView(data)}>
                                <svg viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.0403 1.85156H8.35113C4.12815 1.85156 2.43896 3.54075 2.43896 7.76373V12.8313C2.43896 17.0543 4.12815 18.7435 8.35113 18.7435H13.4187C17.6417 18.7435 19.3309 17.0543 19.3309 12.8313V11.1421" stroke="#08A5DC" stroke-width="1.52027" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M14.2974 2.71332L7.642 9.36873C7.38862 9.62211 7.13524 10.1204 7.08457 10.4836L6.72139 13.0258C6.58626 13.9464 7.2366 14.5883 8.1572 14.4616L10.6994 14.0985C11.0542 14.0478 11.5525 13.7944 11.8143 13.541L18.4697 6.88562C19.6184 5.73697 20.1589 4.40251 18.4697 2.71332C16.7805 1.02413 15.4461 1.56467 14.2974 2.71332Z" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M13.3428 3.66797C13.9087 5.68655 15.488 7.26594 17.5151 7.84027" stroke="#08A5DC" stroke-width="1.52027" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                              </button>
                              <button onClick={() => deleteConfigu(data._id)}>
                                <svg viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M16.6523 4.80811L16.1289 13.2752C15.9952 15.4386 15.9283 16.5202 15.3861 17.2979C15.118 17.6823 14.7728 18.0068 14.3725 18.2507C13.5629 18.7439 12.4792 18.7439 10.3117 18.7439C8.14144 18.7439 7.05629 18.7439 6.24611 18.2498C5.84556 18.0055 5.50029 17.6804 5.23229 17.2953C4.69022 16.5164 4.62483 15.4332 4.49405 13.2668L3.9834 4.80811" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                  <path d="M2.71631 4.80764H17.919M13.7431 4.80764L13.1665 3.61822C12.7835 2.82813 12.592 2.43308 12.2617 2.1867C12.1884 2.13205 12.1108 2.08344 12.0297 2.04134C11.6639 1.85156 11.2249 1.85156 10.3468 1.85156C9.44674 1.85156 8.9967 1.85156 8.62482 2.0493C8.54241 2.09312 8.46376 2.1437 8.3897 2.20052C8.05553 2.45688 7.86887 2.86639 7.49554 3.6854L6.98398 4.80764" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                  <path d="M8.20605 14.0981L8.20605 9.03058" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                  <path d="M12.4292 14.0983L12.4292 9.03076" stroke="#FF5858" stroke-width="1.52027" stroke-linecap="round" />
                                </svg>
                              </button>
                            </div>
                          </TableCell>
                        </TableRow>
                        <hr />
                      </>
                    )) :

                    <TableRow className='' sx={{ marginBottom: 2 }}>
                      {/* <TableCell colSpan={3} className='text-center td'></TableCell>
                      <TableCell className='text-center td'>No result</TableCell>
                      <TableCell colSpan={3} className='text-center td'></TableCell> */}
                    </TableRow>
                  }
                </TableBody>
              </Table>

            </TableContainer>
            {/* Pagination */}
            <div className="d-flex justify-content-end mt-3">
              <Pagination
                count={Math.ceil(configurations.filter(d => d.type.toLowerCase() === type.toLowerCase()).length / rowsPerPage)}
                page={page}
                onChange={handlePageChange}
                className="custom-pagination"

              />
            </div>
          </div>
        </div>
      </div>
      {/* adding a new Package modal */}

      <Dialog className='p-0'
        open={openNew}
        keepMounted
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="container-fluid">
          <div className="row ">
            <div className="col-md-12 px-0 m-0">
              <form onSubmit={editedConfig ? updateConfigu : addNewConfigu}>
                <div className="card add_new_modal px-2">
                  <div className="card-header bg-white">
                    {editedConfig ? `Edit ${type.endsWith('ss') ? type : type.endsWith('ies') ? type.slice(0, -3) + 'y' : type.endsWith('s') ? type.slice(0, -1) : type}` : `Add new ${type.endsWith('ss') ? type : type.endsWith('ies') ? type.slice(0, -3) + 'y' : type.endsWith('s') ? type.slice(0, -1) : type}`}

                  </div>
                  <div className="card-body pt-0">
                    <div className="row  py-2">
                      {editedConfig &&
                        <div className="col-md-12 mt-2 mb-2 justify-content-between d-flex">
                          <div className="d-flex left">
                            <h5>Activation</h5>
                          </div>
                          <div className="right my-auto d-flex">
                            <p className='me-2 my-auto'>{isActive ? "Active" : "Inactive"}</p>
                            <label className="switch my-auto">
                              <input type="checkbox" checked={isActive}
                                onChange={handleToggle} />
                              <span className="slider round"></span>
                            </label>

                          </div>
                        </div>
                      }

                      {/* Flight Class */}
                      {type==='flight class'&&
                       <div className="data my-1 col-md-12 px-1">
                       <label htmlFor="" >Flight Class:</label>
                       <input type="text" value={flight_class} placeholder='Flight class' onChange={(e) => setflight_class(e.target.value)} className='mt-1' id="" />
                     </div>
                      }
                          {/* Airports */}
                      {type==='airports'&&
                       <div className="data my-1 col-md-6 px-1">
                       <label htmlFor="" >Name:</label>
                       <input type="text" value={airport_name} placeholder='Airport name' onChange={(e) => setairport_name(e.target.value)} className='mt-1' id="" />
                     </div>
                      }
                       {/* Airlines  or Hotels*/}
                       {(type==='airlines'||type==='hotels')&&
                       <div className={`data my-1 ${type==='hotels'?'col-md-12':'col-md-6'} px-1`}>
                       <label htmlFor="" >Name:</label>
                       <input type="text" value={name} placeholder='Name here' onChange={(e) => setname(e.target.value)} className='mt-1' id="" />
                     </div>
                      }
                      {/* Combined */}
                      {(type==='airports'||type==='airlines')&&
                       <>
                       <div className="data my-1 col-md-6 px-1">
                       <label htmlFor="" >Country:</label>
                       <input type="text" value={country} placeholder='Country name' onChange={(e) => setcountry(e.target.value)} className='mt-1' id="" />
                     </div>
                     <div className="data my-1 col-md-6 px-1">
                       <label htmlFor="" >IATA Code:</label>
                       <input type="text" value={iata_code} placeholder='IATA code' onChange={(e) => setiata_code(e.target.value)} className='mt-1' id="" />
                     </div>
                     <div className="data my-1 col-md-6 px-1">
                       <label htmlFor="" >ICAO Code:</label>
                       <input type="text" value={icao_code} placeholder='ICAO code' onChange={(e) => seticao_code(e.target.value)} className='mt-1' id="" />
                     </div>
                       </>
                      }

                    {type==='airlines'&&
                       <>
                       <div className="data my-1 col-md-6 px-1">
                       <label htmlFor="" >Call Sign:</label>
                       <input type="text" value={callsign} placeholder='Call sign' onChange={(e) => setcallsign(e.target.value)} className='mt-1' id="" />
                     </div>

                     <div className="data my-1 col-md-6 px-1">
                       <label htmlFor="" >Logo:</label>
                       <input type="file" onChange={handleImage} className='mt-1' id="" />
                     </div>
                       </>
                      }
                      <hr />
                      <div className="text-end mt-1 pb-0">
                        <button className="btn cancel_btn mx-2  py-2" type='button' onClick={() => handleCloseNew()} disabled={loading1}>Cancel</button>
                        <button className="btn save_btn mx-2 " type='submit' disabled={loading1}>{loading1 ? "Saving" : "Save"}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Dialog>




    </div>
  )
}
